import { BooleanSelectOption, SelectOption } from '@storage/app/models'
import { useMemo } from 'react'

const KEY_PREFIX = 'DAMAGED'

export const useDamagedOptions = (): SelectOption[] =>
  useMemo(
    () => [
      { label: `${KEY_PREFIX}.DAMAGED`, value: BooleanSelectOption.True },
      { label: `${KEY_PREFIX}.NON_DAMAGED`, value: BooleanSelectOption.False },
    ],
    [],
  )
